import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'

import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import Checkbox from '@mui/material/Checkbox'

import { TextBlock } from '../../../components/1elements'

const HierarchicalSearch = ({ bucket, formikProps, editMode }) => {
  const selection = bucket.selection

  const fullList = bucket.fullList
  const categoriesWithSubCategories = bucket.categoryList.filter(
    parent =>
      bucket.categoryList.some(child => child.id === parent.id)
  )
  const topLevelCategories = bucket.categoryList
    .filter(c => !c.parent_id)
    .map(c => {
      if (categoriesWithSubCategories.some(i => i.id === c.id))
        c.hasSubCategory = true
      return c
    })

  const [selectedTab, setSelectedTab] = useState(0)
  const [tempSelection, setTempSelection] = useState(selection)

  const handleChange = (event, newValue) => {
    setSelectedTab(newValue)
  }

  const TabPanel = props => {
    const { children, value, index, ...other } = props

    return (
      <div
        role='tabpanel'
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Typography component={'span'}>{children}</Typography>
        )}
      </div>
    )
  }

  function findWithAttr (array, attr, value) {
    for (var i = 0; i < array.length; i += 1) {
      if (array[i][attr] === value) {
        return i
      }
    }
    return -1
  }

  const handleToggle = item => () => {
    const id = item.id
    const currentIndex = findWithAttr(tempSelection, 'id', id)

    console.log(currentIndex)

    const newSelection = [...tempSelection]
    if (currentIndex === -1) {
      newSelection.push(item)
    } else {
      newSelection.splice(currentIndex, 1)
    }
    setTempSelection(newSelection)
    bucket.tempChanges.data = newSelection
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired
  }

  const a11yProps = index => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`
    }
  }

  const renderOneItem = (item, index) => {
    return (
      <ListItem key={index} disablePadding>
        <Checkbox
          edge='start'
          checked={tempSelection.some(o => o.id === item.id)}
          inputProps={{ 'aria-label': 'controlled' }}
          tabIndex={-1}
          disableRipple
          onClick={handleToggle(item)}
        />
        {item.name}
      </ListItem>
    )
  }
  return (
    <Box sx={{ width: '100%', maxHeight: '60`%', scrollBehavior: 'smooth' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={selectedTab} onChange={handleChange}>
          {topLevelCategories.map((c, index) => (
            <Tab key={index} label={c.name} {...a11yProps(index)} />
          ))}
        </Tabs>
      </Box>
      {topLevelCategories.map((oneTopLevelCat, index) => {
        const listOfItems = fullList.filter(
          i => i.category_id === oneTopLevelCat.id
        )
        const listOfSubCategories = bucket.categoryList.filter(
          child => child.parent_id === oneTopLevelCat.id
        )
        return (
          <TabPanel value={selectedTab} index={index} key={index}>
            <List>
              {listOfItems.map((item, index) => renderOneItem(item, index))}
            </List>
            {oneTopLevelCat.hasSubCategory &&
              listOfSubCategories.map((oneSubLevelCat, index) => {
                const childrenOfSubCategory = fullList.filter(
                  i => i.category_id === oneSubLevelCat.id
                )
                return (
                  <TextBlock heading={oneSubLevelCat.name} key={index}>
                    <List key={index}>
                      {childrenOfSubCategory.map((itemUnderSubCat, index) =>
                        renderOneItem(itemUnderSubCat, index)
                      )}
                    </List>
                  </TextBlock>
                )
              })}
          </TabPanel>
        )
      })}
    </Box>
  )
}

export default React.memo(HierarchicalSearch)
